/* title.tsx generated by @compiled/babel-plugin v0.28.8 */
import "./title.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import { element } from '../../core/elements';
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
const titleTextStyle = null;
function Title(_ref) {
  let {
    children
  } = _ref;
  if (!children) return null;
  return /*#__PURE__*/_jsx("h2", {
    className: ax(["_syaz1gjq _11c81bk4 _19pkidpf _2hwxidpf _otyridpf _18u0idpf"]),
    children: children
  });
}
const _Title = element(Title);
export { _Title as Title };